import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useTranslation } from 'react-i18next';
import { openBookDemo } from '../utils/config';

const FAQ = () => {
  const { t } = useTranslation();

  const faqs = [
    t('faq.items.q1', { returnObjects: true }),
    t('faq.items.q2', { returnObjects: true }),
    t('faq.items.q3', { returnObjects: true }),
    t('faq.items.q4', { returnObjects: true }),
    t('faq.items.q5', { returnObjects: true }),
    t('faq.items.q6', { returnObjects: true }),
    t('faq.items.q7', { returnObjects: true }),
    t('faq.items.q8', { returnObjects: true })
  ];

  return (
    <section id="faq" className="py-24 bg-gray-900">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-gray-300">
            {t('faq.subtitle')}
          </p>
        </div>
        
        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={faq.question || `faq-${index}`} 
                value={`item-${index}`}
                className="border-2 border-gray-700 bg-gray-800/50 backdrop-blur-sm rounded-xl px-6 hover:border-blue-500/50 transition-colors duration-300"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-white hover:text-blue-400 py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        
        {/* Still Have Questions CTA */}
        <div className="text-center mt-16 p-8 bg-gradient-to-r from-blue-900/50 to-blue-800/50 backdrop-blur-sm rounded-2xl max-w-4xl mx-auto border border-blue-500/30">
          <h3 className="text-2xl font-bold text-white mb-4">
            {t('contact.title')}
          </h3>
          <p className="text-gray-300 mb-6">
            {t('contact.subtitle')}
          </p>
          <button 
            onClick={openBookDemo}
            className="inline-flex items-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
          >
            {t('nav.bookDemo')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
